import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/useinfo/img-banner-top.png'
import _imports_1 from '@/assets/useinfo/icon-chatbubble.png'


const _withScopeId = n => (_pushScopeId("data-v-1338af6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-banner",
  src: _imports_0,
  alt: "상단 배너"
}, null, -1))
const _hoisted_3 = { class: "main-block--wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "오토콜, 이럴 때 이용하세요!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "채팅 아이콘"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "주차한 차량에 문제가 발생했을 때 연락을 받고 싶은데...")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text space--top" }, "자주 묻는 질문", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_logo = _resolveComponent("header-logo")!
  const _component_useinfo_card_thumbnail = _resolveComponent("useinfo-card-thumbnail")!
  const _component_useinfo_collapse_menu = _resolveComponent("useinfo-collapse-menu")!
  const _component_useinfo_button_sticky = _resolveComponent("useinfo-button-sticky")!
  const _component_useinfo_slider_image = _resolveComponent("useinfo-slider-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_logo),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", null, [
          _createVNode(_component_useinfo_card_thumbnail, {
            slideItem: _ctx.slideItem1,
            imageSRC: 'assets/useinfo/img-thumbnail-01.png',
            title: '차량에 휴대폰번호는\n노출하고 싶지 않아요'
          }, null, 8, ["slideItem", "imageSRC"]),
          _createVNode(_component_useinfo_card_thumbnail, {
            slideItem: _ctx.slideItem2,
            imageSRC: 'assets/useinfo/img-thumbnail-02.png',
            title: '모르는 사람과의 통화가\n부담스럽고 불편해요'
          }, null, 8, ["slideItem", "imageSRC"])
        ]),
        _hoisted_6,
        _createElementVNode("div", null, [
          _createVNode(_component_useinfo_collapse_menu)
        ])
      ])
    ]),
    _createVNode(_component_useinfo_button_sticky),
    (_ctx.isSlideShown)
      ? (_openBlock(), _createBlock(_component_useinfo_slider_image, {
          key: 0,
          slideItems: _ctx.slideItems
        }, null, 8, ["slideItems"]))
      : _createCommentVNode("", true)
  ], 64))
}